import { HigherKeyMode } from "@eweadn-qiankun/shared-types";
import type { KeyConfig } from "../components/Keyboard/types";
import { KEYBOARD_LAYOUTS } from "./keyCodeMapper";
import { resolveLayoutKeyDisplayLabel } from "./keyboardLayoutUtils";
/** 高级键角标：按物理坐标稳定索引（layout 刷新后 uuid 可能变化） */
export function advancedKeyPositionModeKey(row: number, col: number): string {
  return `pos:${row}-${col}`;
}

export function resolveAdvancedKeyModeForKey(
  key: Pick<KeyConfig, "uuid" | "originalRow" | "originalCol">,
  modes?: Record<string, HigherKeyMode>
): HigherKeyMode | undefined {
  if (!modes) return undefined;
  const byUuid = modes[key.uuid];
  if (byUuid !== undefined) return byUuid;
  if (key.originalRow == null || key.originalCol == null) return undefined;
  return modes[advancedKeyPositionModeKey(key.originalRow, key.originalCol)];
}

export function hasAdvancedKeyModeOnCell(
  key: Pick<KeyConfig, "uuid" | "originalRow" | "originalCol">,
  modes: Record<string, HigherKeyMode>
): boolean {
  return resolveAdvancedKeyModeForKey(key, modes) !== undefined;
}

/** 高级键槽位改键后 layout.label 可能为空，用静态配列默认键名回显物理键 */
export function resolveAdvancedKeyPhysicalLabel(
  cell: { originalRow?: number; originalCol?: number; label?: string },
  keyboardType: string,
  solutionProvider?: string
): string {
  const current = String(cell.label ?? "").trim();
  if (current) return current;
  const row = cell.originalRow;
  const col = cell.originalCol;
  if (row == null || col == null) return "";
  const matrix = (KEYBOARD_LAYOUTS as Record<string, number[][]>)[keyboardType];
  const defaultCode = matrix?.[row]?.[col];
  if (!defaultCode) return "";
  return resolveLayoutKeyDisplayLabel(defaultCode, keyboardType as any, {
    firmwareRow: row,
    firmwareCol: col,
    solutionProvider,
  });
}
